import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Inquiry.css";

const InquiryForm = () => {
  const initialFormData = {
    name: "",
    company: "",
    email: "",
    phone: "",
    industry: "",
    privacyAgreement: false,
    inquiryContent: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://fte30k7x40.execute-api.ap-northeast-1.amazonaws.com/prod/inquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setSubmitted(true);
        setMessage(
          "お問い合わせありがとうございます。<br />担当者が内容を確認し、2〜3営業日以内にご連絡いたします。"
        );
        setFormData(initialFormData);
      } else {
        setSubmitted(true);
        setMessage("送信に失敗しました。お手数ですが、再度お試しください。");
      }
    } catch (error) {
      console.error("送信エラー:", error);
      setSubmitted(true);
      setMessage(
        "エラーが発生しました。ネットワークをご確認のうえ、再度お試しください。"
      );
    }
  };

  return (
    <div className="inquiry-section">
      <h2 className="inquiry-title">お問い合わせ</h2>
      <p className="inquiry-subtitle">
        お気軽にお問い合わせください。<br></br>
        フォーム送信完了後、担当者よりご連絡させていただきます。
      </p>

      <div className="inquiry-form-container">
        <div className="inquiry-container">
          <form onSubmit={handleSubmit}>
            <label className="inquiry-label">
              <div className="label-with-required">
                担当者名<span className="required">必須</span>
              </div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="inquiry-label">
              <div className="label-with-required">
                会社名<span className="required">必須</span>
              </div>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="inquiry-label">
              <div className="label-with-required">
                メールアドレス<span className="required">必須</span>
              </div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="inquiry-label">
              <div className="label-with-required">
                電話番号<span className="required">必須</span>
              </div>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="inquiry-label">
              <div className="label-with-required">
                業種<span className="required">必須</span>
              </div>
              <input
                type="text"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="inquiry-label">
              <div className="label-with-required">
                お問い合わせ内容<span className="required">必須</span>
              </div>
              <textarea
                name="inquiryContent"
                value={formData.inquiryContent}
                onChange={handleChange}
                required
                className="inquiry-textarea"
              />
            </label>

            <label className="inquiry-label checkbox-container3">
              <input
                type="checkbox"
                name="privacyAgreement"
                checked={formData.privacyAgreement}
                onChange={handleChange}
                required
              />
              <span>
                弊社の
                <Link
                  to="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  プライバシーポリシー
                </Link>
                に同意する
              </span>
            </label>

            <div className="Inquiry-button-container">
              <button className="Inquiry-button">お問い合わせを送信する</button>
            </div>
            {submitted && (
              <div
                className="inquiry-success-message"
                dangerouslySetInnerHTML={{ __html: message }}
              />
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default InquiryForm;
